/* eslint-disable no-magic-numbers */
// 皮肤-360渠道
import React, { useCallback, useState, useEffect } from 'react'
import styles from './skin-360.module.scss'
import classNames from 'classnames'
import { Input, Toast, Button, Modal, Swiper } from 'antd-mobile'
import { parseNum, isPhone, Storage, isAndroid } from '@bihu/common-js'
import BigNumber from 'bignumber.js'
import getHostNameObj from '@/hooks/get-host-name-obj'
import { TOKEN, ENTER_AGREEMENT, CURRENT_SKIN_INDEX } from '@/constants/storage'
import NumberInput from '@/components/number-input/number-input'
import activityApi from '@/apis/activity'
import { addCachedParamsToLogin, clearCachedParams, getCachedParamsAsQueryString } from '@/utils/login-params'
import { useSearchParams } from 'react-router-dom'
import loanCalculateUtils from 'loan-calculate-utils'
interface Props {
  onCallBackParams: (data: any) => void,
  callBack: () => void,
  type?: 'getQuota', // 领取额度
  channelDetail: any // 渠道详情
  phoneValue: string // 手机号
}

const Skin5: React.FC<Props> = props => {
  const { callBack, type, channelDetail, phoneValue } = props
  const hostNameObj = getHostNameObj()

  const [search] = useSearchParams()

  // 渠道编码
  const [adChannelCode, setAdChannelCode] = useState('')
  // 调起位置授权
  const loginAfterLocation = () => {
    let isHandleCopyFunction = true
    let hasHandleCopyFunction = false
    // 开始执行位置授权
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          // 获取到的地理位置 position
          isHandleCopyFunction = false
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(position.coords.latitude, position.coords.longitude)
        },
        error => {
          // 获取位置失败
          isHandleCopyFunction = false
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(null, null)
        },
      )
      setTimeout(() => {
        // 执行备用方案
        if (isHandleCopyFunction) {
          hasHandleCopyFunction = true
          getUserLocation(null, null)
        }
      }, 8000)
    } else {
      getUserLocation(null, null)
    }
  }
  const getUserLocation = async(latitude:any, longitude:any) => {
    let params = latitude ? {
      location: `${latitude},${longitude}`,
      adChannelCode: channelDetail.adChannelCode,
      coordtype: 'wgs84ll',
    } : {
      adChannelCode: channelDetail.adChannelCode,
    }
    const res:any = await activityApi.reverseGeo(params)
    if (res.data.excludeCity && channelDetail.linkType === 2) {
      await activityApi.reportDevice({
        provinceName: res.data.province,
        cityName: res.data.city,
      })
      window.location.href = `/fill-information/success?options=${encodeURIComponent(JSON.stringify({
        isNotFormReq: true,
        isSpecialListCity: true
      }))}`
    } else {
      // 如果不在白名单，报告父组件，执行正常跳转的逻辑
      callBack()
    }
  }
  useEffect(() => {
    const hasToken = Storage.get(TOKEN)
    const code = search.get('adChannelCode')
    if (code) {
      setAdChannelCode(code)
      localStorage.setItem('ad_channel_code', code)
      // 是否需要获取定位
      if (hasToken && channelDetail.location) {
        loginAfterLocation()
      }
    }
  }, [])

  // 手机号码
  const [phone, setPhone] = useState(phoneValue)
  // 验证码
  const [code, setCode] = useState('')

  // 是否显示验证码弹窗
  const [showPopup, setShowPopup] = useState('')

  // 选择协议
  const [checked, setChecked] = useState(false)
  // 是否抖动
  const [isShake, setIsShake] = useState(false)
  // 切换选中协议
  const checkedTaggle = () => {
    setChecked(!checked)
  }

  // 最小金额3万
  const [min] = useState(30000)
  // 最大金额20万
  let [max] = useState(200000)

  // 借款金额
  const [amount, setAmount] = useState<any>(30000)

  const amountRecommendArr:any = [
    {
      label: '￥10,000',
      value: 10000
    },
    {
      label: '￥25,000',
      value: 25000
    },
    {
      label: '全部借出',
      value: 200000
    },
  ]

  // 当前选中期数
  const [currentPeriods, setCurrentPeriods] = useState<number>(12)
  // 还款明细
  const [eachIssueList, setEachIssueList] = useState<any>({ list: [] })
  // 还款日期
  const [repayDate, setRepayDate] = useState([])
  // 还款明细展示
  const [showDetail, setShowDetail] = useState(false)
  // 借款金额改变
  const amountOnChange = (str: string) => {

    str = str.replace(/[^\d]/g, '')
    let newValue:number | string = str
    if (+str > max) {
      // newValue = max
    }
    newValue = parseNum(newValue as unknown as number)
    if (newValue && newValue !== '0') {
      setAmount(newValue)
    } else {
      setAmount('')
    }
  }

  // 失去焦点
  const amountOnBlur = () => {
    let str = amount.replace(/[^\d]/g, '')
    max = 200000
    if (+str > max) {
      setAmount(parseNum(max))
      return Toast.show('您可借最大金额为200000元')
    }
    if (+str < min) {
      setAmount(parseNum(min))
      return Toast.show('最低可借金额为30000元起')
    }
  }

  // 月利率
  const [monthlyInterestRate] = useState(0.0056)

  // 每月需还金额 = （借款金额 + 总利息）/ 期数
  const monthRepayAmountFn = useCallback((currentMonth:number) => {
    const amountNew = amount.replace(',', '')

    if (!amountNew) {
      return '0'
    }

    let val = new BigNumber(amountNew).plus(totalInterest(currentMonth))
      .div(currentMonth)
      .toFixed(2)

    return val
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount])

  // 总利息 = 借款金额*月利率*期数
  const totalInterest = useCallback((currentMonth:number) => {
    const amountNew = amount.replace(',', '')

    if (!amountNew) {
      return '-'
    }

    let val = new BigNumber(amountNew).multipliedBy(monthlyInterestRate)
      .multipliedBy(currentMonth)
      .toFixed(2)

    return val
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount])

  // 跳转页面
  const openView = (path: string) => {
    Storage.set(ENTER_AGREEMENT, true)
    window.location.href = `/${path}-agreement?isShowHeader=true`
  }

  // 定时器对象
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>()
  // 当前倒计时剩余时间
  const [time, setTime] = useState(0)

  // 倒计时时间
  const countDownTime = 60
  // 倒计时函数
  const countDownFn = () => {
    setTime(countDownTime)
  }

  useEffect(() => {
    if (time > 0) {
      let t = setTimeout(() => {
        setTime(time - 1)
      }, 1000)
      setTimer(t)
    } else {
      timer && clearTimeout(timer)
      setTimer(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time])

  // 获取验证码
  const getCode = async() => {
    if (!phone) {
      return Toast.show('请输入手机号码')
    }
    if (!isPhone(phone)) {
      return Toast.show('手机号码格式有误')
    }
    countDownFn()

    try {
      await activityApi.smsSend({
        mobile: +phone
      })
    } catch (error) {
      timer && clearTimeout(timer)
    }

    // Toast.show('获取验证码成功')
  }

  const openPopup = () => {
    if (!amount) {
      return Toast.show('请输入借款金额')
    }
    if (!phone) {
      return Toast.show('请输入手机号码')
    }
    if (!isPhone(phone)) {
      return Toast.show('手机号码格式有误')
    }
    if (!checked) {
      setIsShake(true)
      setTimeout(() => {
        setIsShake(false)
      }, 100)
      return Toast.show('请勾选注册及隐私协议')
    }
    if (!time) {
      getCode()
    }
    setShowPopup('true')
  }

  // 立即注册
  const register = async() => {
    if (!code) {
      return Toast.show('请输入验证码')
    }
    try {
      Toast.show({
        icon: 'loading',
        content: '领取中…',
        duration: 0,
      })
      const abTestType = 5
      const queryString = getCachedParamsAsQueryString()
      const loginParams = {
        mobile: phone,
        code,
        adChannelCode,
        abTestType,
        isFormReq: (type === 'getQuota' && adChannelCode !== 'YxNj9v'),
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const res = await activityApi.login(loginParams, queryString)
      Storage.set(TOKEN, res.token)
      // 登录成功后清除缓存的参数
      clearCachedParams()
      props.onCallBackParams({
        amount: amount.replace(/[^\d]/g, ''),
        currentPeriods
      })
      if (channelDetail.location) {
        loginAfterLocation()
      } else {
        callBack()
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error:any) {
      Toast.clear()
      Toast.show(error.msg)
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }
  const parmasData = () => {
    return {
      amount: amount.replace(/[^\d]/g, ''),
      currentPeriods
    }
  }

  const [swiperList, setSwiperList] = useState<{ label: string }[]>([])
  useEffect(() => {
    getUserInfo()
  }, [])
  // 领取用户生成
  const getUserInfo = () => {
    let price = [30000, 35000, 40000, 45000, 50000, 60000, 80000, 85000, 100000, 105000, 110000, 115000, 120000, 125000, 130000, 135000, 140000, 145000, 150000, 155000, 160000, 165000, 200000]
    let name = ['赵', '钱', '孙', '李', '周', '吴', '郑', '王', '张', '刘', '陈', '杨', '罗', '黄', '江', '朱', '马', '林', '何', '郭', '许', '邓', '田']
    for (let i = 0; i < 30; i++) {
      let index = Math.floor(Math.random() * price.length)
      setSwiperList(prev => [
        ...prev, {
          label: `正规品牌 恭喜${name[i]}XX用户成功放款${price[index]}元`,
        }
      ])
    }
  }

  useEffect(() => {
    if (currentPeriods || amount) {
      calcAverageCapital()
      generateNextTwelveMonths()
    }
  }, [currentPeriods, amount])

  // 每期还款金额
  const calcAverageCapital = () => {
    let amountValue = 0
    if (typeof amount === 'string') {
      amountValue = Number(amount.replace(/[^\d]/g, ''))
    } else {
      amountValue = amount
    }
    let result = loanCalculateUtils.calcAverageCapital({
      amount: Number(amountValue), // 贷款金额
      term: Number(currentPeriods), // 贷款期数(月数)
      rate: Number(7.2) // 年利率
    })
    setEachIssueList(result)
  }
  // 选择期数
  const periodsFun = (item:number) => {
    setCurrentPeriods(item)
  }

  // 生成未来月的今天的还款日期
  const generateNextTwelveMonths = () => {
    const today = new Date()
    const result: any = []
    for (let i = 0; i < currentPeriods; i++) {
      const d = new Date(today.getFullYear(), today.getMonth() + i, today.getDate())
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const date = d.getDate()
      result.push(`${year}-${month}-${date}`)
    }
    setRepayDate(result)
  }

  return (
    <div className={styles.skin5}>
      <div className={styles.notice}>
        <img className={styles.noticeImg} src={require('@imgs/register/wft/inform.png')} />
        <Swiper indicator={() => null} autoplay loop>
          {
            swiperList.map((item, index) => (
              <Swiper.Item key={index} className={styles.swiperItem}>
                {item.label}
              </Swiper.Item>
            ))
          }
        </Swiper>
      </div>
      <div className={styles.usable}>
        <img className={styles.usableImg} src={require('@imgs/register/wft/suucessIcon.png')} />
        <div className={styles.usableText}>
          恭喜, 您的账户可取用
        </div>
      </div>
      {/* 借款金额 */}
      <div className={styles.borrowing}>
        <div className={styles.borrowingTitle}>最高可借200000元</div>
        <div className={styles.money}>
          <div className={styles.moneyMain}>
            <div className={styles.moneyMainL}>
              <div className={styles.moneyMainSymbol}>￥</div>
              <NumberInput
                className={styles.moneyMainNum}
                value={amount}
                onChange={amountOnChange}
                onBlur={amountOnBlur}
                numberFormat={{
                  decimal: false,
                  negative: false,
                  leadingZero: false,
                  maxLength: 6
                }}
                placeholder={''}
              />
            </div>
            <div className={styles.moneyMainR}>
              <div className={styles.moneyMainRText}>(金额可修改)</div>
              <img onClick={() =>
                setAmount('')
              } className={styles.moneyMainRImg} src={require('@imgs/register/wft/closeIcon.png')} />
            </div>
          </div>
        </div>
        <div className={styles.borrowingTip}>年化利率 7.2%-24%，提前还无手续费</div>
      </div>
      {/* 借款期数 */}
      <div className={styles.periods}>
        <div className={styles.periodsTop}>
          <div className={styles.periodsTopText}>借多久</div>
          <div className={styles.periodsRate}>年利率低 , 借1000元用1天<span>0.2</span>元</div>
        </div>
        <div className={styles.periodsMain}>
          {
            [6, 9, 12].map(item => {
              return <div key={item} className={classNames(styles.periodsMainItem, item === currentPeriods && styles.active)} onClick={() => periodsFun(item)}>
                {item}个月
              </div>
            })
          }
        </div>
      </div>
      {/* 还款明细 */}
      <div className={styles.repayment}>
        <div className={styles.repaymentTop}>
          <div className={styles.repaymentTopL}>
            <div className={styles.repaymentTopLText}>还款明细</div>
            <div className={styles.repaymentTopLSum}>总利息 ¥{eachIssueList.totalInterest}</div>
          </div>
          <div className={styles.repaymentTopR}>
            <div className={styles.repaymentTopRText} onClick={() => setShowDetail(!showDetail)}>展开</div>
            <img className={styles.repaymentTopRImg} src={require('@imgs/register/wft/unfoldIcon.png')} />
          </div>
        </div>
        <div className={styles.eachIssue}>
          {
            eachIssueList.list.map((item: { monthlyPayment: string; principal: string; interest: string }, index: number) => (
              (showDetail || index < 2) && <div key={index} className={styles.eachIssueItem}>
                <div className={styles.eachIssueItemL}>
                  <div className={styles.eachIssueItemLText}>{index === 0 ? '首期' : `${index + 1}期`}</div>
                  <div className={styles.eachIssueItemLDate}>{repayDate[index]}</div>
                  <img className={styles.eachIssueItemLImg} src={require('@imgs/register/wft/circle.png')} />
                </div>
                <div className={styles.eachIssueItemR}>
                  <div className={styles.eachIssueItemRTitle}>应还 ¥{item.monthlyPayment}</div>
                  <div className={styles.eachIssueItemRText}>本金¥{item.principal}+利息约¥{item.interest}</div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      {/* 立即领取 */}
      <div className={styles.operate}>
        <div className={styles.phoneBox}>
          <NumberInput
            placeholder="请输入本人实名认证手机号"
            value={phone}
            numberFormat={{
              decimal: false,
              negative: false,
              leadingZero: false,
              maxLength: 11
            }}
            onChange={val => {
              setPhone(val)
            }}
          />
        </div>
        <div className={styles.getQuotaBox}>
          <div className={styles.getQuota} onClick={openPopup}>去领取</div>
          <div className={styles.getQuotaText}>名额有限 尽快领取</div>
          <img className={styles.getQuotaImg} src={require('@imgs/register/wft/click.gif')} alt="" />
        </div>
        <div className={styles.agreement}>
          <i className={classNames(styles.checked, checked && styles.active)} onClick={checkedTaggle}></i>
          阅读并同意
          <span className={styles.primary}
            onClick={() => {
              openView('register')
            }}>《用户注册服务协议》</span>
          和
          <span className={styles.primary} onClick={() => {
            openView('privacy')
          }}>《隐私政策》</span>
        </div>
      </div>

      <div className={styles.tipBox}>
        <div className={styles.tip}>本平台是信息服务平台，不提供放贷业务</div>
        <div className={styles.tip}>平台向您展示的贷款产品或贷款咨询服务是由贷款服务机构</div>
        <div className={styles.tip}>(泛指为您提供贷款咨询服务或贷款发放服务的机构)</div>
        <div className={styles.tip}>或贷款中介咨询机构提供</div>
        <div className={styles.tip}>平台展示的贷款产品年利率范围7.2%-24%</div>
        <div className={styles.tip}>具体利率以第三方实际放款结果为准</div>
        <div className={styles.tip}>您最终获取的贷款额度、利率、放款时间</div>
        <div className={styles.tip}>以第三方机构实际审批结果为准</div>
        <div className={styles.tip}>温馨提示:请根据个人能力合理贷款，理性消费，避免逾期</div>
        <div className={styles.tip}>请不要相信任何要求您支付费用的信息、邮件、电话等不实信息</div>
        <div className={styles.tip}>
          闽ICP备2024074549号-1 | 厦门乐真网络科技有限公司
        </div>
        <div className={styles.tip}>客服电话：4006686025</div>
      </div>
      <div className={classNames(styles.dialogOverlay, showPopup && styles.showPopup)}>
        <div className={styles.dialogMain}>
          <div className={styles.close} onClick={() => setShowPopup('')}>X</div>
          <div className={styles.inputBox}>
            <NumberInput
              placeholder="请输入验证码"
              value={code}
              numberFormat={{
                decimal: false,
                negative: false,
                maxLength: 6
              }}
              onChange={val => {
                setCode(val)
              }}
            />
            {
              time ? <span className={classNames(styles.code, styles.codeText)}>剩余 {time}s</span>
                : <span className={styles.code} onClick={getCode}>获取验证码</span>
            }
          </div>
          <div className={styles.getQuota} onClick={register}>获取额度</div>
        </div>
      </div>
    </div>
  )
}

export default Skin5
